import React, { useEffect, useState } from "react";
import { reduxForm, Field, FieldArray } from "redux-form";
import { Header, Grid, Label, Button } from "semantic-ui-react";
import { renderTextField, renderOptionField } from "../formcomponents";
import TourDayItenery from "./TourDayItenery";
import axios from "axios";
import { BaseUrl, BaseUrlInvoice } from "../formcomponents/Constants";
import { useParams } from "react-router-dom";
import { HotelData } from "./HotelData";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import validate from "./validate";

const CreateTourPackage = (props) => {
  const { handleSubmit, pristine, reset, submitting } = props;
  const navigate = useNavigate();

  const { id } = useParams();

  useEffect(() => {
    if (id) {
      getTourPackageDetail();
    }
  }, []);

  const getTourPackageDetail = async () => {
    await axios
      .post(BaseUrl + "getTourPackageDetails", { ssTourPackageId: id })
      .then((res) => {
        console.log("----------------------------->", res.data);
        initializeData(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const initializeData = (prevData) => {
    props.initialize({
      ...prevData,
    });
  };

  const sumbitForm = async (values) => {
    console.log(JSON.stringify(values, null, 2));

    await axios
      .post(BaseUrl + "createTourPackage", values)
      .then((res) => {
        console.log(`Response data`, JSON.stringify(res.data, null, 2));

        if (res.data.errorCode === 200) {
          Swal.fire({
            icon: "success",
            title: "sccess",
            text: `${id == "null" ? "Created" : "Updated"}`,
          });
          navigate(-1);
        }
      })
      .catch((error) => {
        console.log(error);
      });
    // if(id){

    //   console.log("iugasfdiuygasfyigasydgcf iashf iahf iufhiahsid ia iashd iaushdi sadich gsadi isad yi")
    //   await axios
    //   .post(BaseUrl + "editTourPackage", values)
    //   .then((res) => {
    //     console.log(`Response data`, JSON.stringify(res.data, null, 2));
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
    // }else{

    // }
  };
  return (
    <div>
      <Header dividing size="huge" as="h1">
        Create Tour Package Invoive
      </Header>

      <Grid.Row>
        <Grid columns="ten">
          <Grid.Row>
            <Grid.Column>
              <Field
                name="tourDate"
                label="Date"
                type="date"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="invoiceNumber"
                label="Invoice Number"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="customerName"
                label="Customer Name"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="phoneNumber"
                label="Contact  Number"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="hotelName"
                label="Hotel Name"
                options={HotelData}
                component={renderOptionField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="roomType"
                label="Room Type"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="nofDays"
                label="Number Of Days"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="nofAdult"
                label="Adult"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="nofChild"
                label="Child"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="tourCost"
                label="Cost"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Row>
      <br />
      <h2>Day Wise Itenery</h2>
      <br />

      <FieldArray name="tourItenaryList" component={TourDayItenery} />

      <>
        <Button
          floated="right"
          positive
          onClick={handleSubmit((values) =>
            sumbitForm({
              ...values,
            })
          )}
        >
          Save
        </Button>
        <Button
          floated="right"
          negative
          disabled={pristine || submitting}
          onClick={reset}
        >
          Cancel
        </Button>{" "}
      </>
    </div>
  );
};

export default reduxForm({
  form: "CreateTourPackage",
  validate,
})(CreateTourPackage);
